import React, { useState } from 'react';
import { connect } from 'react-redux';
import { NotificationEmbed } from '@exploreorg/explore-comments';
import BlockSection from './BlockSection';
import FollowingSection from './FollowingSection';
import FollowersSection from './FollowersSection';
import NotificationSettingsModal from '../../components/Modals/NotificationSettingsModal';
import { setNotificationExceptions } from '../../actions/uiPreferences';
import { commentsConfig } from '../../utils';


function NotificationsSection({ token, updateExceptions, notificationExceptions, commentToken }) {
  const conf = commentsConfig();
  const [isNotificationSettingsModalOpen, setNotificationSettingsModalOpen] = useState(false);

  const closeModal = () => {
    setNotificationSettingsModalOpen(false);
  };

  return (
    <div className="row bg-fff-80 mt-3 pb-3">
      <div className="col-12 col-md-8">
        <div>
          <h2 className="py-3 d-inline-block">Notifications</h2>
        </div>
        <NotificationEmbed
          config={conf}
          token={commentToken}
          except={notificationExceptions}
          dropdown={false}
          onSettingsClick={() => setNotificationSettingsModalOpen(!isNotificationSettingsModalOpen)}
        />
        <NotificationSettingsModal
          isOpen={isNotificationSettingsModalOpen}
          onClose={closeModal}
          id="pg"
        />
      </div>
      <div className="col-12 col-md-4">
        <BlockSection />
        <FollowingSection />
        <FollowersSection />
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    commentToken: state.auth.commentToken,
    notificationExceptions: state.uiPreferences.notificationExceptions || [],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateExceptions: exceptions => dispatch(setNotificationExceptions(exceptions)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsSection);
